import { Map } from 'immutable'
import React from 'react'
import Input from './Input'

const langs = ['fi', 'en', 'se']

export default function TranslatableTextField(props) {
  let { value, onChange, name } = props

  if (!Map.isMap(value)) value = Map()

  return (
    <div className="field-item field-item--translatable translatable">
      {langs.map(lang => {
        return (
          <div className="translatable-item" key={lang}>
            <div className="translatable-item-lang">{lang}</div>
            <div className="translatable-item-input">
              <Input
                name={`${name}-${lang}`}
                value={value.get(lang, '')}
                onChange={e => {
                  let { value: langValue } = e.target || e
                  onChange({ name, value: value.set(lang, langValue) })
                }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
